module.exports = __webpack_public_path__ + "static/media/ic_location_activate.1082a1cc.svg";